module.exports = "/_next/static/images/creators-how-it-works-a543e27f7d5c7750954bdb6d2ebf0b81.png";